import { render, staticRenderFns } from "./verCartelera.vue?vue&type=template&id=6d3f512e&scoped=true"
import script from "./verCartelera.vue?vue&type=script&lang=js"
export * from "./verCartelera.vue?vue&type=script&lang=js"
import style0 from "./verCartelera.vue?vue&type=style&index=0&id=6d3f512e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f512e",
  null
  
)

export default component.exports